import clsx from "clsx";
import {
  forwardRef,
  type HTMLAttributes,
  type TdHTMLAttributes,
  type ThHTMLAttributes,
} from "react";

type TableProps = HTMLAttributes<HTMLTableElement>;

const Table = forwardRef<HTMLTableElement, TableProps>(
  ({ className, ...props }, ref) => {
    return (
      <table
        ref={ref}
        className="mb-auto border-separate border-spacing-0 overflow-hidden border border-black-200 rounded-3xl"
        {...props}
      />
    );
  },
);
Table.displayName = "Table";

const TableHead = forwardRef<
  HTMLTableHeaderCellElement,
  ThHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }, ref) => (
  <th
    ref={ref}
    className={clsx(
      "text-left text-button-xs text-black-500 pl-2.5 first:pl-3 h-10 border-b border-black-200 last:text-right last:pr-1.5",
      className,
    )}
    {...props}
  />
));
TableHead.displayName = "TableHead";

const TableRow = forwardRef<
  HTMLTableRowElement,
  ThHTMLAttributes<HTMLTableRowElement>
>(({ className, ...props }, ref) => (
  <tr ref={ref} className={clsx("group", className)} {...props} />
));
TableRow.displayName = "TableRow";

const TableCell = forwardRef<
  HTMLTableCellElement,
  TdHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }, ref) => {
  return (
    <td
      ref={ref}
      className={clsx(
        "pl-2.5 last:text-right border-b-black-200 border-b py-3 first:pl-3 last:pr-3 group-last:border-b-0",
        className,
      )}
      {...props}
    />
  );
});
TableCell.displayName = "TableCell";

export { Table, TableCell, TableHead, TableRow };
